<script>
    import { alphabetStore } from '../../store/alphabet';
    import { lettersWithItemsStore } from '../../store/letters-with-items';

    export let isActive;
    export let letter = '';

    let disabled = false;

    function onClick() {
        if (!disabled) {
            alphabetStore.setActiveLetter(letter);
        }
    }

    function isDisabled(lettersWithItems) {
        return lettersWithItems.indexOf(letter) < 0;
    }

    lettersWithItemsStore.subscribe((lwi) => {
        disabled = isDisabled(lwi);
    });

</script>

<li role="presentation" class:active={isActive} class:disabled>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a
        role="tab"
        href="#"
        tabindex="-1"
        on:click|preventDefault={onClick(letter)}
    >
        {letter}
    </a>
</li>

<style>
    li {
        scroll-snap-align: end;
        scroll-margin-right: 2rem;
    }

    li:first-child {
        scroll-snap-align: start;
        scroll-margin-left: 2rem;
    }

    .disabled,
    .disabled a {
        color: #ddd;
        cursor: auto;
    }

    .disabled:hover,
    .disabled:hover a {
        color: #ddd;
    }

</style>
